import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  complianceTemplate: null,
  complianceItems: [],
  loading: false,
  error: null,
};

const complianceSlice = createSlice({
  name: "compliance",
  initialState,
  reducers: {
    fetchComplianceTemplate(state, action) {
      state.complianceTemplate = action.payload;
    },
    fetchComplianceItems(state, action) {
      state.complianceItems = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    updateComplianceItemStatus(state, action) {
      const { itemId, status } = action.payload;
      const item = state.complianceItems.find((i) => i.id === itemId);
      if (item) {
        item.status = status;
      }
    },
    clearCompliance(state) {
      state.complianceTemplate = null;
      state.complianceItems = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchComplianceTemplate,
  fetchComplianceItems,
  setLoading,
  setError,
  updateComplianceItemStatus,
  clearCompliance,
} = complianceSlice.actions;

export default complianceSlice.reducer;

